import { render, staticRenderFns } from "./ReceivingRecord.vue?vue&type=template&id=162fc4e5&scoped=true&"
import script from "./ReceivingRecord.vue?vue&type=script&lang=js&"
export * from "./ReceivingRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingRecord.vue?vue&type=style&index=0&id=162fc4e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162fc4e5",
  null
  
)

export default component.exports